import {ROUTER_URL} from '@/utils/enums';
import {useEffect} from 'react';
import {useNavigate, useSearchParams} from 'react-router-dom';
import Modal from '@/shared/components/Modal';
import ForgotPasswordModal from '@/components/Organization/Login/ForgotPasswordModal';
import OrganizationLogin from '@/pages/Organization/OrganizationLogin';
import {formContentStyle} from '@/components/Organization/Login/LoginForm/FormContent/FormContent.styles';
import Home from '@/pages/User/Home';
import UserTemplate from '@/layouts/UserTemplate';

const ResetPasswordHandler = () => {
	const [searchParams] = useSearchParams();
	const navigate = useNavigate();

	const code = searchParams.get('code');
	const returnUrl = searchParams.get('returnUrl');

	useEffect(() => {
		if (!code) {
			navigate(ROUTER_URL.LOGIN, {replace: true});
		}
	}, [code, navigate]);

	const handleClose = () => {
		const target = returnUrl ? (returnUrl.startsWith('/') ? returnUrl : `/${returnUrl}`) : ROUTER_URL.LOGIN;

		navigate(target, {replace: true});
	};

	if (!code) return null;

	return (
		<>
			{returnUrl ? (
				<UserTemplate>
					<Home slugFromProps={returnUrl} />
				</UserTemplate>
			) : (
				<OrganizationLogin />
			)}
			<Modal open onClose={handleClose} sx={formContentStyle.modal}>
				<ForgotPasswordModal onCloseModal={handleClose} />
			</Modal>
		</>
	);
};

export default ResetPasswordHandler;
